module.exports = __webpack_public_path__ + "img/maeve.db58da3.webp";